import * as classNames from 'classnames';
import { computed, observable } from 'mobx';
import { observer } from 'mobx-react';
import * as React from 'react';

// Styles
const s = require('./Checkbox.css');
const tickWhite = require('assets/tick white.svg');
const tickDim = require('assets/tick dim.svg');

// Props
interface ICheckboxProps {
    onChange?: (checked: boolean, value: any) => void;
    className?: string;
    align?: 'left' | 'center' | 'right';
    checked?: boolean;
    disabled?: boolean;
    value: any;
    valueUnchecked?: any;
    label?: string;
    labelOnLeft?: boolean;
}

// Component
@observer
export class Checkbox extends React.Component<ICheckboxProps, {}> {
    static get defaultProps(): ICheckboxProps {
        return {
            onChange: null,
            className: null,
            align: 'left',
            checked: false,
            disabled: false,
            value: true,
            valueUnchecked: null,
            label: '',
            labelOnLeft: false,
        };
    }

    @observable private checked: boolean = this.props.checked;

    public componentWillUpdate(nextProps: ICheckboxProps) {
        if (
            this.props.checked !== nextProps.checked &&
            nextProps.checked !== this.checked
        ) {
            this.checked = nextProps.checked;
        }
    }

    public render() {
        return (
            <label
                className={classNames(s.checkbox, this.props.className, {
                    [s.alignLeft]: this.props.align === 'left',
                    [s.alignCenter]: this.props.align === 'center',
                    [s.alignRight]: this.props.align === 'right',
                    [s.labelOnLeft]: this.props.labelOnLeft,
                    [s.checked]: this.checked,
                    [s.disabled]: this.props.disabled,
                })}
            >
                {this.props.labelOnLeft === true && this.renderLabel()}

                <input
                    tabIndex={-1}
                    onChange={this.handleCheckboxToggle}
                    disabled={this.props.disabled}
                    type="checkbox"
                    value={this.props.value}
                    checked={this.checked}
                />

                {this.props.labelOnLeft === false && this.renderLabel()}

                <button
                    tabIndex={this.props.disabled ? -1 : undefined}
                    onClick={this.handleIconButtonClick}
                    className={s.icon}
                >
                    <img src={this.checked ? tickWhite : tickDim} />
                </button>
            </label>
        );
    }

    private renderLabel = () => {
        return <p>{this.props.label}</p>;
    };

    private handleIconButtonClick = (
        e: React.MouseEvent<HTMLButtonElement>
    ) => {
        e.preventDefault();
        e.stopPropagation();

        this.handleCheckboxToggle();
    };

    private handleCheckboxToggle = () => {
        if (this.props.disabled === false) {
            const isChecked = !this.checked;
            this.checked = isChecked;

            if (this.props.onChange) {
                this.props.onChange(
                    isChecked,
                    isChecked ? this.props.value : this.props.valueUnchecked
                );
            }
        }
    };
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./app/web/src/components/action/Checkbox.tsx